// extracted by mini-css-extract-plugin
export var formContainer = "_kp-0";
export var message = "_kp-1";